import { RankedDivisionTypes, RankedSubDivisionTypes } from '@colonist/leaderboard-types';
import IconRankBronze from '@static/images/ranking_divisions/bronze.svg';
import IconRankSilver from '@static/images/ranking_divisions/silver.svg';
import IconRankGold from '@static/images/ranking_divisions/gold.svg';
import IconRankPlatinum from '@static/images/ranking_divisions/platinum.svg';
import IconRankDiamond from '@static/images/ranking_divisions/diamond.svg';
import IconRankMaster from '@static/images/ranking_divisions/master.svg';
import IconRankGrandmaster from '@static/images/ranking_divisions/grandmaster.svg';
import IconRankSubdivisionI from '@static/images/ranking_divisions/subdivisions_i.svg';
import IconRankSubdivisionII from '@static/images/ranking_divisions/subdivisions_ii.svg';
import IconRankSubdivisionIII from '@static/images/ranking_divisions/subdivisions_iii.svg';
import IconRankSubdivisionIV from '@static/images/ranking_divisions/subdivisions_iv.svg';
import IconRankSubdivisionV from '@static/images/ranking_divisions/subdivisions_v.svg';
import IconXMark from '@static/images/icon_x.svg';
// TODO @Dang This constant should be moved to clientforge
export const RANKED_DIVISION_IMAGE_PATH = {
    [RankedDivisionTypes.Bronze]: IconRankBronze,
    [RankedDivisionTypes.Silver]: IconRankSilver,
    [RankedDivisionTypes.Gold]: IconRankGold,
    [RankedDivisionTypes.Platinum]: IconRankPlatinum,
    [RankedDivisionTypes.Diamond]: IconRankDiamond,
    [RankedDivisionTypes.Master]: IconRankMaster,
    [RankedDivisionTypes.Grandmaster]: IconRankGrandmaster,
    [RankedDivisionTypes.None]: IconXMark
};
// TODO @Dang This constant should be moved to clientforge
export const RANKED_SUBDIVISION_IMAGE_PATH = {
    [RankedSubDivisionTypes.None]: undefined,
    [RankedSubDivisionTypes.I]: IconRankSubdivisionI,
    [RankedSubDivisionTypes.II]: IconRankSubdivisionII,
    [RankedSubDivisionTypes.III]: IconRankSubdivisionIII,
    [RankedSubDivisionTypes.IV]: IconRankSubdivisionIV,
    [RankedSubDivisionTypes.V]: IconRankSubdivisionV
};
export function isHigherDivision(first, second) {
    if (first.divisionType < second.divisionType) return true;
    if (first.divisionType > second.divisionType) return false;
    if (first.subdivisionType < second.subdivisionType) return true;
    return false;
}
